import type { TaskListData } from '../types';
import { MOCK_STATUSES } from './statuses.mock';

const [STATUS_TODO, STATUS_IN_PROGRESS, STATUS_QA, STATUS_DONE] = MOCK_STATUSES;

export const MOCK_TASK_LIST_DATA: TaskListData = {
  groups: [
    { id: 'group-1', name: 'Backend', color: 'indigo-nebula', projectId: 'mock-project' },
    { id: 'group-2', name: 'Frontend', color: 'teal-lagoon', projectId: 'mock-project' },
  ],
  tasks: [
    {
      id: 'task-1',
      title: 'Set up authentication endpoints',
      status: STATUS_DONE,
      priority: 'high',
      assignee: { id: 'user-1', name: 'Ana García', avatarUrl: undefined, color: 'indigo-nebula' },
      dueDate: { date: '2025-04-20' },
      startDate: { date: '2025-04-10' },
      groupId: 'group-1',
      tagIds: ['tag-1', 'tag-2'],
      subtaskCount: 3,
      isCompleted: true,
      order: 0,
      subtasks: [
        {
          id: 'task-1-sub-1',
          title: 'Implement JWT token generation',
          status: STATUS_DONE,
          priority: 'high',
          assignee: {
            id: 'user-1',
            name: 'Ana García',
            avatarUrl: undefined,
            color: 'indigo-nebula',
          },
          dueDate: { date: '2025-04-18' },
          groupId: 'group-1',
          subtaskCount: 0,
          isCompleted: true,
          order: 0,
        },
        {
          id: 'task-1-sub-2',
          title: 'Add refresh token endpoint',
          status: STATUS_DONE,
          priority: 'medium',
          assignee: {
            id: 'user-1',
            name: 'Ana García',
            avatarUrl: undefined,
            color: 'indigo-nebula',
          },
          dueDate: { date: '2025-04-19' },
          groupId: 'group-1',
          subtaskCount: 0,
          isCompleted: true,
          order: 0,
        },
        {
          id: 'task-1-sub-3',
          title: 'Write authentication middleware',
          status: STATUS_DONE,
          priority: 'medium',
          assignee: null,
          dueDate: { date: '2025-04-20' },
          groupId: 'group-1',
          subtaskCount: 0,
          isCompleted: true,
          order: 0,
        },
      ],
    },
    {
      id: 'task-2',
      title: 'Design database schema for projects',
      status: STATUS_IN_PROGRESS,
      priority: 'high',
      assignee: {
        id: 'user-2',
        name: 'Carlos López',
        avatarUrl: undefined,
        color: 'green-emerald',
      },
      dueDate: { date: '2025-04-30' },
      startDate: { date: '2025-04-15' },
      groupId: 'group-1',
      subtaskCount: 0,
      isCompleted: false,
      order: 1,
    },
    {
      id: 'task-3',
      title: 'Write API integration tests',
      status: STATUS_TODO,
      priority: 'medium',
      assignee: null,
      dueDate: { date: '2025-05-05' },
      groupId: 'group-1',
      subtaskCount: 0,
      isCompleted: false,
      order: 2,
    },
    {
      id: 'task-4',
      title: 'Implement task list pagination',
      status: STATUS_TODO,
      priority: 'low',
      assignee: { id: 'user-1', name: 'Ana García', avatarUrl: undefined, color: 'indigo-nebula' },
      dueDate: undefined,
      groupId: 'group-1',
      subtaskCount: 2,
      isCompleted: false,
      order: 3,
      subtasks: [
        {
          id: 'task-4-sub-1',
          title: 'Add cursor-based pagination to API',
          status: STATUS_IN_PROGRESS,
          priority: 'low',
          assignee: {
            id: 'user-1',
            name: 'Ana García',
            avatarUrl: undefined,
            color: 'indigo-nebula',
          },
          dueDate: undefined,
          groupId: 'group-1',
          subtaskCount: 0,
          isCompleted: false,
          order: 0,
        },
        {
          id: 'task-4-sub-2',
          title: 'Implement infinite scroll in list view',
          status: STATUS_TODO,
          priority: 'low',
          assignee: null,
          dueDate: undefined,
          groupId: 'group-1',
          subtaskCount: 0,
          isCompleted: false,
          order: 0,
        },
      ],
    },
    {
      id: 'task-5',
      title: 'Build task list view component',
      status: STATUS_IN_PROGRESS,
      priority: 'high',
      assignee: { id: 'user-3', name: 'María Torres', avatarUrl: undefined, color: 'coral-flame' },
      dueDate: { date: '2025-04-28' },
      startDate: { date: '2025-04-18' },
      groupId: 'group-2',
      subtaskCount: 5,
      isCompleted: false,
      order: 4,
      subtasks: [
        {
          id: 'task-5-sub-1',
          title: 'Define table column structure',
          status: STATUS_DONE,
          priority: 'high',
          assignee: {
            id: 'user-3',
            name: 'María Torres',
            avatarUrl: undefined,
            color: 'coral-flame',
          },
          dueDate: { date: '2025-04-20' },
          groupId: 'group-2',
          subtaskCount: 0,
          isCompleted: true,
          order: 0,
        },
        {
          id: 'task-5-sub-2',
          title: 'Implement group-by logic',
          status: STATUS_DONE,
          priority: 'high',
          assignee: {
            id: 'user-3',
            name: 'María Torres',
            avatarUrl: undefined,
            color: 'coral-flame',
          },
          dueDate: { date: '2025-04-22' },
          groupId: 'group-2',
          subtaskCount: 0,
          isCompleted: true,
          order: 0,
        },
        {
          id: 'task-5-sub-3',
          title: 'Add sortable column headers',
          status: STATUS_IN_PROGRESS,
          priority: 'medium',
          assignee: {
            id: 'user-2',
            name: 'Carlos López',
            avatarUrl: undefined,
            color: 'green-emerald',
          },
          dueDate: { date: '2025-04-25' },
          groupId: 'group-2',
          subtaskCount: 0,
          isCompleted: false,
          order: 0,
        },
        {
          id: 'task-5-sub-4',
          title: 'Integrate inline editing for title',
          status: STATUS_QA,
          priority: 'medium',
          assignee: {
            id: 'user-3',
            name: 'María Torres',
            avatarUrl: undefined,
            color: 'coral-flame',
          },
          dueDate: { date: '2025-04-27' },
          groupId: 'group-2',
          subtaskCount: 0,
          isCompleted: false,
          order: 0,
        },
        {
          id: 'task-5-sub-5',
          title: 'Add empty state and loading skeleton',
          status: STATUS_TODO,
          priority: 'low',
          assignee: null,
          dueDate: { date: '2025-04-28' },
          groupId: 'group-2',
          subtaskCount: 0,
          isCompleted: false,
          order: 0,
        },
      ],
    },
    {
      id: 'task-6',
      title: 'Create reusable form field components',
      status: STATUS_DONE,
      priority: 'medium',
      assignee: { id: 'user-3', name: 'María Torres', avatarUrl: undefined, color: 'coral-flame' },
      dueDate: { date: '2025-04-15' },
      groupId: 'group-2',
      subtaskCount: 0,
      isCompleted: true,
      order: 5,
    },
    {
      id: 'task-7',
      title: 'Set up i18n for tasks namespace',
      status: STATUS_TODO,
      priority: 'medium',
      assignee: null,
      dueDate: { date: '2025-05-10' },
      groupId: 'group-2',
      subtaskCount: 0,
      isCompleted: false,
      order: 6,
    },
    {
      id: 'task-8',
      title: 'Accessibility audit for list view',
      status: STATUS_TODO,
      priority: 'low',
      assignee: {
        id: 'user-2',
        name: 'Carlos López',
        avatarUrl: undefined,
        color: 'green-emerald',
      },
      dueDate: undefined,
      groupId: 'group-2',
      subtaskCount: 0,
      isCompleted: false,
      order: 7,
    },
  ],
};
